import { feeCategoriesApi } from '../api/feeCategoriesApi';
import { serviceFeeApi } from '../api/serviceFeeApi';
import { ApartmentFeeCategory } from '../api/apartmentsApi';

export async function submitApartmentServiceFeeInvoice(
  data: {
    type: 'FIXED' | 'USAGE_BASED' | 'OTHER';
    apartmentId: string;
    feeCategoryId?: string;
    billingPeriod: string;
    quantity?: number;
    accessCardId?: string;
    startReading?: number;
    endReading?: number;
    amount?: number;
    utilityMeterId?: string;
    notes?: string;
    fromDate?: string;
    dueDate?: string;
    applyToAllApartments?: boolean;
    contractId?: string;
  },
  feeCategories?: ApartmentFeeCategory[],
): Promise<void> {
  if (data.type === 'FIXED') {
    await serviceFeeApi.createFixedServiceFee({
      apartmentId: data.apartmentId,
      feeCategoryId: data.feeCategoryId!,
      billingPeriod: data.billingPeriod,
      quantity: data.quantity,
      accessCardId: data.accessCardId,
      fromDate: data.fromDate ?? '',
      dueDate: data.dueDate ?? '',
      contractId: data.contractId,
    });
    return;
  }

  if (data.type === 'USAGE_BASED') {
    let amount = data.amount;
    const feeCategory = feeCategories?.find((fc) => fc.feeCategoryId === data.feeCategoryId);
    if (feeCategory?.feeCategory.pricingType === 'QUOTA_BASED') {
      const usage = (data.endReading || 0) - (data.startReading || 0);
      const calculationResult = await feeCategoriesApi.calculateQuotaBasedFee(
        feeCategory.feeCategoryId,
        usage,
        'STAFF',
        'STAFF',
        data.apartmentId,
      );
      amount = calculationResult.totalAmount;
    }

    await serviceFeeApi.createUsageServiceFee({
      apartmentId: data.apartmentId,
      feeCategoryId: data.feeCategoryId!,
      billingPeriod: data.billingPeriod,
      startReading: data.startReading ?? 0,
      endReading: data.endReading ?? 0,
      amount: amount!,
      utilityMeterId: data.utilityMeterId,
      fromDate: data.fromDate ?? '',
      dueDate: data.dueDate ?? '',
    });
    return;
  }

  await serviceFeeApi.createOtherServiceFee({
    apartmentId: data.apartmentId,
    billingPeriod: data.billingPeriod,
    amount: data.amount!,
    notes: data.notes,
    fromDate: data.fromDate ?? '',
    dueDate: data.dueDate ?? '',
    applyToAllApartments: data.applyToAllApartments || false,
  });
}
